export const TEXT_FONT = 'GalerijaJosefinSans';

export const loadAppFont = async () => {
  const font = new FontFace(
    TEXT_FONT,
    'url(./fonts/GalerijaJosefinSans-Regular.otf)'
  );
  document.fonts.add(await font.load());
};
